import { useEffect, useState } from "react";
import type { MeResponse } from "@salon-pos/shared";
import { api } from "../api";

/** (Task NN) may this member open 投诉与建议 / Feedback? */
export const canSeeFeedback = (me: MeResponse | null | undefined) => !!me?.membership && (me.permissions["feedback.view"] ?? "none") !== "none";

/**
 * Unread platform replies / status changes on the member's tickets (user menu, Feedback page, store app Me tab).
 * Polls every 2 minutes and whenever refreshKey changes; 0 without the permission or offline.
 */
export function useFeedbackBadge(enabled: boolean, refreshKey = ""): number {
  const [n, setN] = useState(0);
  useEffect(() => {
    if (!enabled) { setN(0); return; }
    let stop = false;
    const tick = async () => { try { const r = await api<{ unread: number }>("/api/feedback/unread"); if (!stop) setN(r.unread ?? 0); } catch { /* keep the last count */ } };
    void tick();
    const id = setInterval(() => void tick(), 120_000);
    const on = () => void tick();
    window.addEventListener("spos:feedback-changed", on);
    return () => { stop = true; clearInterval(id); window.removeEventListener("spos:feedback-changed", on); };
  }, [enabled, refreshKey]);
  return n;
}
export const feedbackChanged = () => { try { window.dispatchEvent(new Event("spos:feedback-changed")); } catch { /* not in a browser */ } };

/** short device description for the ticket context: "Android · Chrome 140 · 412×915" */
export function deviceLabel(ua = typeof navigator === "undefined" ? "" : navigator.userAgent): string {
  const os = /iPad/.test(ua) ? "iPad" : /iPhone/.test(ua) ? "iPhone" : /Android/.test(ua) ? "Android" : /Windows/.test(ua) ? "Windows" : /Mac OS X|Macintosh/.test(ua) ? "macOS" : /Linux/.test(ua) ? "Linux" : "";
  const m = /(Edg|OPR|Chrome|Firefox|Version)\/(\d+)/.exec(ua);
  const br = m ? (m[1] === "Edg" ? "Edge" : m[1] === "OPR" ? "Opera" : m[1] === "Version" ? "Safari" : m[1]) + " " + m[2] : "";
  const size = typeof window !== "undefined" && window.innerWidth ? window.innerWidth + "×" + window.innerHeight : "";
  return [os, br, size].filter(Boolean).join(" · ").slice(0, 200) || "unknown";
}
